import { render, staticRenderFns } from "./ChinaVis2022.md?vue&type=template&id=267c3c9e&"
import script from "./ChinaVis2022.md?vue&type=script&lang=js&"
export * from "./ChinaVis2022.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports